// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PasswordIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M6 7v18a1 1 0 1 1-2 0V7a1 1 0 0 1 2 0Zm10.5 6.813-2.5.812V12a1 1 0 0 0-2 0v2.625l-2.5-.813a1.002 1.002 0 0 0-.625 1.903l2.5.811-1.543 2.125a1 1 0 1 0 1.618 1.175l1.543-2.125 1.542 2.125a1 1 0 1 0 1.617-1.175l-1.542-2.125 2.5-.811a1 1 0 0 0-.61-1.902Zm13.25.642a1 1 0 0 0-1.25-.643l-2.5.813V12a1 1 0 0 0-2 0v2.625l-2.5-.811a.998.998 0 0 0-1.307 1.03 1.001 1.001 0 0 0 .688.872l2.5.812-1.542 2.125a.999.999 0 1 0 1.617 1.175L25 17.703l1.542 2.125a.999.999 0 1 0 1.618-1.175l-1.543-2.125 2.5-.812a1 1 0 0 0 .634-1.261Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
